

//Отображение пустого списка сообщений
export default function Empty() {

	return <p>У вас пока нет сообщений</p>
}